import React from "react";
import { ResultValueType } from "../../enums/result-value-type.enum";
import { PanelResultDetails } from "../../store/slices/order/types";
import { RenderRichText } from "../base";

const ResultValue = ({
  resultDetails,
}: {
  resultDetails: PanelResultDetails;
}) => {
  const displayResultValue = (resultValueType: ResultValueType) => {
    switch (resultValueType) {
      case ResultValueType.Integer:
        return (
          <div className="">
            <RenderRichText
              content={`${resultDetails?.strValue}${
                resultDetails.unit ? resultDetails?.unit : ""
              }`}
            />
          </div>
        );
      case ResultValueType.Edit1:
      case ResultValueType.String:
      case ResultValueType.String20:
      case ResultValueType.String3:
      case ResultValueType.String4:
      case ResultValueType.String5:
        return (
          <div className="">
            <RenderRichText
              content={`${resultDetails?.strValue}${
                resultDetails.unit ? resultDetails?.unit : ""
              }`}
            />
          </div>
        );
      case ResultValueType.LST:
        return (
          <>
            <div className="flex justify-center text-center">
              {resultDetails?.strValue.toUpperCase()}
            </div>
          </>
        );
      case ResultValueType.Culture:
        return (
          <div className="flex justify-center text-center">
            {/* <RenderRichText content={resultDetails?.resultValue} /> */}
          </div>
        );
      default:
        return (
          <div>
            {resultDetails?.strValue}
            <RenderRichText content={resultDetails?.unit || ""} />
          </div>
        );
    }
  };
  return (
    <div className="flex justify-center text-[1rem]">
      {displayResultValue(resultDetails?.valueType as ResultValueType) ||
        "---------------"}
    </div>
  );
};

export default ResultValue;
